import FallbackLoader from '../../../../loaders/components/FallbackLoader';

export default FallbackLoader(
  () => import(/* webpackChunkName: "async-HandleAddressesModal" */'./content'),
  { fallback: null },
);
